import { createSelector } from 'reselect';
const getRevisionsData = state => {
  //when in universal theme editor in content editor
  //theme editor will not have this state
  if (state.themeRevisions) {
    return state.themeRevisions;
  }
  return state.revisions || [];
};
export const getRevisions = createSelector([getRevisionsData], revisionsData => revisionsData.revisions && revisionsData.revisions.sort((a, b) => {
  const aTimestamp = a.updatedAt;
  const bTimestamp = b.updatedAt;
  if (aTimestamp > bTimestamp) return -1;
  if (aTimestamp < bTimestamp) return 1;
  return 0;
}));
export const getHasMoreRevisions = createSelector([getRevisionsData], revisionsData => revisionsData.hasMoreRevisions);
export const getRequestOffset = createSelector([getRevisionsData], revisionsData => revisionsData.requestOffset);
export const getTotalRevisionCount = createSelector([getRevisionsData], revisionsData => revisionsData.totalRevisionCount);
export const getRevertThemeSettingsRequestStatus = createSelector([getRevisionsData], revisionsData => revisionsData.revertRequestStatus);
export const getRevisionsRequestStatus = createSelector([getRevisionsData], revisionsData => revisionsData.requestStatus);